import _ from 'lodash';

export default (function (AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelContext) {
    var translateFn = TranslateService.instant;

    var ACTION_MSGS = {
        saveSubmission: {
            error: {
                title: 'quoteandbind.common.config.FlowConfig.Unable to save submission',
                message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.'
            },
            progress: {
                message: 'quoteandbind.common.config.FlowConfig.Saving quote...'
            }
        }
    };

    var ACTIONS = {
        saveDraftSubmission: function saveDraftSubmission(_ref) {
            var submission = _ref.value;
            return LoadSaveService.saveDraftSubmissionAndPrimaryLocation(submission).then(function (submissionDTO) {
                return ViewModelService.create(submissionDTO, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO', ViewModelContext);
            });
        }
    };

    return {
        contactDetails: function contactDetails(step, junction) {
            step('paContactDetails', true).onNext.branch(function (model) {
                // If we come from quick quote go to intermediate step which will save the submission, otherwise
                // carry on as normal to the next state.
                return model.quoteID.value ? 'paQuickQuotePostContactDetails' : 'paContactDetailsComplete';
            }).skipOnResumeIf(function (_ref2, _ref3) {
                var submission = _ref2.value;
                var displayYourInfoStep = _ref3.displayYourInfoStep;
                return !displayYourInfoStep && submission.persons[0].emailAddress1 && submission.persons[0].firstName !== '0dummyname0';
            }).isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Your Info');
            });

            junction('paQuickQuotePostContactDetails').onNext.doAction(ACTIONS.saveDraftSubmission, ACTION_MSGS.saveSubmission).thenGoTo('paContactDetailsComplete', 'error');

            junction('paContactDetailsComplete');
        },
        coverables: function coverables(step, junction) {
            step('paPrequalQuestions', true).onNext.goTo('paDriverDetails').skipOnResumeIf(function (_ref4, _ref5) {
                var submission = _ref4.value;
                var gatewayportalnewsubmission = _ref5.gatewayportalnewsubmission;
                return submission.lobData.personalAuto.preQualQuestionSets && !gatewayportalnewsubmission;
            }).isValid(function (model, isFormValid) {
                return model.aspects.valid && model.aspects.subtreeValid && isFormValid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Qualification');
            });

            step('paDriverDetails').onNext.goTo('paVehicleDetails').skipOnResumeIf(function (_ref6) {
                var submission = _ref6.value;
                return submission.lobData.personalAuto.coverables.drivers[0] && submission.lobData.personalAuto.coverables.drivers[0].licenseNumber && submission.lobData.personalAuto.coverables.drivers[0].licenseNumber !== '0streamlinedquote0';
            }).isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Drivers');
            });

            step('paVehicleDetails').onNext.goTo('paCoverablesComplete').skipOnResumeIf(function (_ref7) {
                var submission = _ref7.value;
                return submission.lobData.personalAuto.coverables.vehicles[0] && _.some(submission.quoteData.offeredQuotes, function (quote) {
                    return quote.status === 'Quoted';
                }) && submission.lobData.personalAuto.coverables.vehicles[0].vin !== '0streamlinedquote0';
            }).isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Vehicles');
            });

            junction('paCoverablesComplete');
        },
        moreInfo: function moreInfo(step, junction) {
            step('paPolicyInfo', true).onNext.goTo('paMoreInfoComplete').skipOnResumeIf(function (_ref8) {
                var submission = _ref8.value;

                return submission.baseData && submission.baseData.accountHolder && submission.baseData.accountHolder.emailAddress1 && (submission.baseData.accountHolder.homeNumber || submission.baseData.accountHolder.workNumber || submission.baseData.accountHolder.cellNumber);
            }).isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Policy Info');
            });

            junction('paMoreInfoComplete');
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=quoteandbind_lob&equals=pa!./common/js/src/edge/quoteandbind/pa/config/FlowConfig.js
// module id = 480
// module chunks = 0